export default {
  getHead: () => {
    return [{name: '회사명'}, {name: '종사자 소속'}, {name: '종사자 부서'}, {name: '종사자 성명'}, {name: '종합의견'}, {name: '작성자'}, {name: '작성일'}]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0: return func.getContent(value).stdInfo.field_name // 회사명
      case 1: return func.getContent(value).stdInfo.department // 종사자 소속
      case 2: return func.getContent(value).inputB_1 // 종사자 부서
      case 3: return func.getContent(value).inputB_2 // 종사자 성명
      case 4: return func.getContent(value).result_4 // 종합의견
      case 5: return func.getContent(value).stdInfo.writer_name // 작성자
      case 6: return func.getCreatedDate(value.created_at) // 작성일
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.created_at) {
      nav.dateTarget = 'created_at'
      nav.dateBegin = 'nav.value.created_at.sDate'
      nav.dateEnd = 'nav.value.created_at.eDate'
    }
    return { searchType: nav.value.searchType, searchKeyword: nav.value.searchKeyword }
  },
  getSearchKeyword: (nav) => {
    const returnData = []

    switch (nav.value.searchType) {
    case '회사명': returnData.push('content$body.stdInfo.field_name*%[:default_skw]%'); break
    case '종사자 소속': returnData.push('content$body.stdInfo.department*%[:default_skw]%'); break
    case '종사자 부서': returnData.push('content$body.inputB_1*%[:default_skw]%'); break
    case '종사자 성명': returnData.push('content$body.inputB_2*%[:default_skw]%'); break
    case '종합의견': returnData.push('content$body.result_4*%[:default_skw]%'); break
    case '작성자': returnData.push('content$body.stdInfo.writer_name*%[:default_skw]%'); break
    }
    return returnData
  },
}
